import { render } from "./sosVue.vue?vue&type=template&id=7c30a5b0&scoped=true"
import script from "./sosVue.vue?vue&type=script&lang=js"
export * from "./sosVue.vue?vue&type=script&lang=js"

import "../assets/css/animauxnew.css?vue&type=style&index=0&id=7c30a5b0&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c30a5b0"]])

export default __exports__